import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';
import './MoveStepper.css';

const STEP_LABELS = [
  'campaigns.move.stepDestination',
  'campaigns.move.stepSelection',
  'campaigns.move.stepConfirmation',
];

const statusOf = (stepNumber, currentStep) => {
  if (stepNumber < currentStep) return 'completed';
  return stepNumber === currentStep ? 'current' : 'pending';
};

const MoveStepper = ({ currentStep }) => (
  <ol className="move-stepper">
    {STEP_LABELS.map((label, index) => {
      const stepNumber = index + 1;
      const status = statusOf(stepNumber, currentStep);
      return (
        <li
          key={label}
          className={`step ${status}`}
          data-step={stepNumber}
          data-status={status}
        >
          <span
            className={`step-circle ${
              status === 'completed' ? 'material-symbols-rounded' : ''
            }`}
          >
            {status === 'completed' ? 'check' : stepNumber}
          </span>
          <span className="step-label">{I18n.t(label)}</span>
        </li>
      );
    })}
  </ol>
);

MoveStepper.propTypes = {
  currentStep: PropTypes.oneOf([1, 2, 3, 4]).isRequired,
};

export default MoveStepper;
